<div class="lump-sum-allowance-container">
  <form [formGroup]="yourLumpSumAllowanceForm" autocomplete="off" role="form" class="fieldHeight">
    <div *ngIf="contentData" class="float-left bg-white card-background-fullwidth">
      <div class="row">
        <app-content-top-nav [parentElement]="el" [parentFormToValidate]="yourLumpSumAllowanceForm"
          [visibleBackNav]='true' [enableBackNav]='true' (onBackClickHandler)="goBack()"></app-content-top-nav>
      </div>
      <div class="row">
        <div class="col-md-12 clear-all title-inner-container">
          <h1 class="custom-header-h2 responsive-text-8" id="beforeYouStart-header">{{contentData.header}}</h1>
        </div>
      </div>
      <div class="content-container">
        <div class="row">
          <div class="col-md-12">
            <div class="col-md-12 bg-mr bg-lightblue">
              <p class="inner-content-data" id="string_LumpSumpContent">{{contentData.string_lsaRulesText}}</p>
            </div>
          </div>
        </div>
        <div class="row wrapperMargin">
          <div class="col-md-12">
            <span class="content-top mt-0 font-size-20" id="yourLumpSumpAllowance-introduction"
              [innerHTML]="contentData.string_YourLumpSumAllowances_paragraph1"></span>
          </div>
        </div>
        <div class="row wrapperMargin">
          <div class="col-md-12">
            <p class="content-top mt-0 font-size-20" id="yourLumpSumpAllowance-introduction">
              {{contentData.string_YourLumpSumAllowances_paragraph2}}
            </p>
          </div>
        </div>
        <div class="row wrapperMargin">
          <div class="col-md-12">
            <p class="content-top mt-0 font-size-20" id="yourLumpSumpAllowance-introduction">
              {{contentData.string_YourLumpSumAllowances_paragraph3}}
            </p>
          </div>
          <div class="row question-container">
            <app-question [childId]="'lsaQuestion'" [questionConfig]="contentData.lsaQuestion"
              [parent]="yourLumpSumAllowanceForm" [controlName]="'lsaQuestion'"
              (toggleChange)="toggleChangeTFCAllowance($event,'lsaQuestion')">
            </app-question>
          </div>
          <div class="row question-container">
            <app-question [childId]="'lsDbaQuestion'" [questionConfig]="contentData.lsDbaQuestion"
              [parent]="yourLumpSumAllowanceForm" [controlName]="'lsDbaQuestion'"
              (toggleChange)="toggleChangeTFCAllowance($event,'lsDbaQuestion')">
            </app-question>
          </div>
          <div class="row question-container">
            <app-question
              *ngIf="yourLumpSumAllowanceForm.get('lsaQuestion').value === 'Y' || yourLumpSumAllowanceForm.get('lsDbaQuestion').value === 'Y'"
              [childId]="'lsaLgaProtectionQuestion'" [questionConfig]="contentData.lsaLgaProtectionQuestion"
              [parent]="yourLumpSumAllowanceForm" [controlName]="'lsaLgaProtectionQuestion'"
              (toggleChange)="toggleChangeTFCAllowance($event,'lsaLgaProtectionQuestion')">
            </app-question>
          </div>
        </div>
        <div class="row wrapperMargin"
          *ngIf="yourLumpSumAllowanceForm.get('lsaLgaProtectionQuestion') && yourLumpSumAllowanceForm.get('lsaLgaProtectionQuestion').value === 'Y'">
          <ng-container
            *ngIf="yourLumpSumAllowanceForm.get('lsaLgaProtectionQuestion') && yourLumpSumAllowanceForm.get('lsaLgaProtectionQuestion').value === 'Y'">
            <div class="col-md-12 clear-all">
              <div class="col-md-6 clear-all">
                <app-dropdown [pageName]="'yourLumpSumAllowance'" (onChangeHandler)="ddlChange($event)"
                  [dropdownConfig]="lsaProtectionTypeConfig" [controlName]="'protectionType'"
                  [parent]="yourLumpSumAllowanceForm">
                </app-dropdown>
              </div>
            </div>
            <div *ngIf="displayProtectionTypeWarningMsg" class="col-md-12 clear-all bg-mr bg-lightblue">
              <p class="inner-content-data">{{this.contentData.protectionWarningMessage}}</p>
            </div>
          </ng-container>
        </div>
        <div class="error-flex-container" *ngIf="displayHigherAllowanceWarningMsg">
          <div class="col-md-12 clear-all bg-mr form-validation-error ">
            <i class="icon icon-error error-icon" aria-hidden="true"></i>
            <p class="inner-content-data display-error-message">
              {{this.contentData.string_HigherAllowanceWarningMessageWording}}
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-12 clear-all bottom-container">
        <div class="float-left">
          <app-save [parentElement]="el" [parentFormToValidate]="yourLumpSumAllowanceForm"
            [location]="'contentBottom'"></app-save>
        </div>
        <div class="float-right" [attr.disabled]="true">
          <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="userInputDetail['buttonConfig']"
            [disabled]="displayHigherAllowanceWarningMsg"></app-content-bottom-nav>
        </div>
      </div>
    </div>
  </form>
</div>